import { resolveShowAlertMsg } from './resolve-show-alert-msg.js';
import { getManagerNavAction } from '../manager/manager-nav-registry.js';

function loginUrlFromPageConfig() {
    try {
        const managerEl = document.getElementById('manager-nav-config');
        if (managerEl && managerEl.textContent) {
            const config = JSON.parse(managerEl.textContent);
            if (config.routes && typeof config.routes.managerLogin === 'string') {
                return config.routes.managerLogin;
            }
        }
        const memberEl = document.getElementById('member-nav-config');
        if (memberEl && memberEl.textContent) {
            const config = JSON.parse(memberEl.textContent);
            if (config.pages && typeof config.pages.signIn === 'string') {
                return config.pages.signIn;
            }
        }
        const superEl = document.getElementById('super-nav-config');
        if (superEl && superEl.textContent) {
            const config = JSON.parse(superEl.textContent);
            if (config.routes && typeof config.routes.login === 'string') {
                return config.routes.login;
            }
        }
    } catch (err) {
        return '';
    }
    return '';
}

let redirectingToLogin = false;

export function navigateToLogin(loginUrl) {
    if (redirectingToLogin) {
        return true;
    }
    const url = (typeof loginUrl === 'string' && loginUrl !== '')
        ? loginUrl
        : loginUrlFromPageConfig();
    if (url === '') {
        return false;
    }
    redirectingToLogin = true;
    window.location.assign(url);
    return true;
}

export function isAuthRedirectInFlight() {
    return redirectingToLogin;
}

let reloadingForExpiredPage = false;

function reloadExpiredPage() {
    if (reloadingForExpiredPage || redirectingToLogin) {
        return;
    }
    reloadingForExpiredPage = true;
    window.location.reload();
}

function forbiddenMessageFrom(xhr, fallback) {
    const json = xhr && xhr.responseJSON;
    if (json && typeof json.error === 'string' && json.error !== '') {
        return json.error;
    }
    return fallback || 'You do not have access to this page';
}

function resolveAlertFn(alertFn) {
    if (typeof alertFn === 'function') {
        return alertFn;
    }
    return resolveShowAlertMsg();
}

function tryGoManagerHomeAfterForbidden() {
    try {
        getManagerNavAction('openMgrIndexPage')();
    } catch (err) {
    }
}

export function handleSpaContentAuthError(xhr, options) {
    const opts = options || {};
    const status = xhr && typeof xhr.status === 'number' ? xhr.status : 0;

    if (redirectingToLogin || reloadingForExpiredPage) {
        return true;
    }

    if (status === 401) {
        return navigateToLogin(opts.loginUrl);
    }

    if (status === 403) {
        const message = forbiddenMessageFrom(xhr, opts.forbiddenMessage);
        const alertFn = resolveAlertFn(opts.alert);
        if (alertFn) {
            alertFn(message, 'danger');
        }
        if (typeof opts.onForbidden === 'function') {
            opts.onForbidden();
        } else {
            tryGoManagerHomeAfterForbidden();
        }
        return true;
    }

    if (status === 419) {
        const alertFn = resolveAlertFn(opts.alert);
        if (alertFn) {
            alertFn(opts.expiredPageMessage || 'This page has expired. Reloading…', 'danger');
        }
        reloadExpiredPage();
        return true;
    }

    return false;
}
